import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import NotificationCount from './NotificationCount';
import { store } from '../../../../store/store';
import React from 'react';
import { Provider } from 'react-redux';

loadDOMComponent({
  selector: 'react-notification-count',
  callback: ({ container, context }) => {
    const isSpan = container.getAttribute('span') !== null;
    const classes = container.getAttribute('className');

    ReactDOM.render(
      <Provider store={store}>
        <AppContextProvider {...context}>
          <NotificationCount isSpan={isSpan} classes={classes} />
        </AppContextProvider>
      </Provider>,
      container,
    );
  },
});
